var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantPotAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2.5C5.75 2.22386 5.97386 2 6.25 2H6.75C8.33852 2 9.71077 2.92598 10.3564 4.26761C10.8099 3.45825 11.5061 2.72149 12.405 2.14404C12.7764 1.90546 13.3033 1.96992 13.5818 2.28803C13.8604 2.60614 13.7851 3.05743 13.4137 3.29601C11.4521 4.55615 10.9204 6.64122 11.949 8.10948C12.0045 8.18872 12.0572 8.26737 12.1072 8.34541C12.7366 6.96191 14.131 6 15.75 6H16.25C16.5261 6 16.75 6.22386 16.75 6.5V7C16.75 9.15815 15.0409 10.9171 12.9023 10.9972C12.8929 11.2075 12.8664 11.4099 12.8267 11.604C12.7174 12.1389 12.4917 12.6323 12.3008 13H17.75C18.1642 13 18.5 13.3358 18.5 13.75C18.5 14.1642 18.1642 14.5 17.75 14.5H5.75C5.33579 14.5 5 14.1642 5 13.75C5 13.3358 5.33579 13 5.75 13H10.4535C10.5254 12.8473 10.6039 12.7037 10.6826 12.5597C10.8754 12.2068 11.0694 11.8517 11.1707 11.3557C11.2995 10.7256 11.2436 9.9013 10.5074 8.85035C10.0992 8.2677 9.86274 7.63927 9.78184 7H9.75C7.54086 7 5.75 5.20914 5.75 3V2.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29415 20.6325L6.75 16H16.75L15.2058 20.6325C14.9336 21.4491 14.1693 22 13.3085 22H10.1915C9.33066 22 8.56638 21.4491 8.29415 20.6325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantPotAlt1);
export default __webpack_public_path__ + "static/media/plant-pot-alt-1.4d6e42a5a12267ad3a4111ec4bb712c8.svg";
export { ForwardRef as ReactComponent };